import React from 'react';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import Button from '../../../component/button';
import Image from '../../../component/image';
import { DarkImages, LightImages } from '../../../assets/images/images';
import {
  NotificationCard,
  MSGdetail,
  AvatarDot,
  DesktopIcon,
  RightContent,
  Description,
  MSGtitle,
  MSGtext,
  BottomButton,
  DesktopImage
} from '../styles';
import { BUTTON_TYPE, ICON_SIZE } from '../../../global/constants';
import { DesktopNotificationCardProps } from '../../../interfaces/NotificationInterface';

const DesktopNotificationCard: React.FC<DesktopNotificationCardProps> = ({ onDismiss }) => {
  const { appStore } = rootStore;
  const { themeMode } = appStore || {};

  const backgroundUrl =
    themeMode?.theme === 'dark' ? DarkImages['desktop_background'] : LightImages['desktop_background'];

  return (
    <NotificationCard backgroundUrl={backgroundUrl}>
      <MSGdetail className='deskTopNotification-card'>
        <AvatarDot>
          <DesktopIcon>
            <SVGIcon
              name='desktop-icon'
              width={ICON_SIZE.MD}
              height={ICON_SIZE.MD}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              className='desktop-icon'
            />
          </DesktopIcon>
        </AvatarDot>
        <RightContent>
          <Description>
            <MSGtitle className='desktopNotification-card'>Install Teamcamp to Your Desktop!</MSGtitle>
            <MSGtext className='desktopNotification-card'>
              Install the Teamcamp desktop app now and take your work to the next level with a faster, distraction-free
              experience.
            </MSGtext>
            <BottomButton>
              <Button
                title='Get desktop app'
                variant={BUTTON_TYPE.SECONDARY}
                size='small'
                onClick={() => window.open('https://www.teamcamp.app/download', '_blank')}
              />
              <Button variant={BUTTON_TYPE.TERTIARY} title=' No, Thanks' onClick={onDismiss} size='small' />
            </BottomButton>
          </Description>
          <DesktopImage>
            <Image
              imageKey='desktop_app_mac'
              alt='desktop app image'
              width={156}
              height={98}
              borderRadius='var(--border-radius-6)'
            />
          </DesktopImage>
        </RightContent>
      </MSGdetail>
    </NotificationCard>
  );
};

export default observer(DesktopNotificationCard);
